import { Select, SelectGroup, SelectValue, SelectTrigger, SelectContent, SelectLabel, SelectItem } from './ui/select';
import { Users, SprayCan } from 'lucide-react';

// Reusable grouped staff filter used across Home, Scan Activity and Team Performance.
// Supports aggregate values: 'all', 'team:all' (internal team), 'cc:all' (all cleaning companies).
export default function StaffFilterSelect({ value, onChange, staffList = [], cleaningGroups = [], testid = 'staff-filter-select', showGroups = true, individualLabel = 'My team' }) {
  const hasTeam = staffList.length > 0;
  const hasCC = cleaningGroups.length > 0;
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        data-testid={testid}
        className="w-full h-12 rounded-2xl bg-white border-slate-200 text-sm font-semibold text-slate-700 shadow-sm focus:ring-2 focus:ring-emerald-400 [&>span]:flex [&>span]:items-center [&>span]:gap-2.5"
      >
        <Users size={18} className="text-emerald-500 flex-shrink-0" />
        <SelectValue placeholder="All staff" />
      </SelectTrigger>
      <SelectContent className="rounded-2xl border-slate-200 shadow-xl max-h-80">
        <SelectItem value="all" className="font-semibold">All staff</SelectItem>
        {showGroups && (hasTeam || hasCC) && (
          <SelectGroup>
            <SelectLabel className="text-[11px] uppercase tracking-wide text-slate-400 font-bold">Groups</SelectLabel>
            {hasTeam && <SelectItem value="team:all">My team</SelectItem>}
            {hasCC && <SelectItem value="cc:all">All cleaning companies</SelectItem>}
          </SelectGroup>
        )}
        {hasTeam && (
          <SelectGroup>
            <SelectLabel className="text-[11px] uppercase tracking-wide text-emerald-600 font-bold">{individualLabel}</SelectLabel>
            {staffList.map((s) => (
              <SelectItem key={s.id} value={s.id}>{s.name || s.email}</SelectItem>
            ))}
          </SelectGroup>
        )}
        {hasCC && (
          <SelectGroup>
            <SelectLabel className="text-[11px] uppercase tracking-wide text-purple-600 font-bold">Cleaning companies</SelectLabel>
            {cleaningGroups.map((g) => (
              <SelectItem key={g.id} value={`cc:${g.id}`}>
                <span className="flex items-center gap-1.5"><SprayCan size={12} className="text-purple-500" /> {g.name}</span>
              </SelectItem>
            ))}
          </SelectGroup>
        )}
      </SelectContent>
    </Select>
  );
}
